import React from 'react';
import Actions from '../components/Actions';
import StepsCompute from '../components/StepsCompute';
import CouponBoxHeader from '../components/CouponBoxHeader';
import Coefficient from '../components/Coefficient';
import {useDispatch} from "react-redux";
import {TOGGLE_ACTIVE_STATUS_COUPON_EVENT} from "../../../../store/spirs/actions";
import {CouponEvent} from "../../../../store/spirs/reducers/couponReducer";
import { LiveBadge } from '../../../Results/LiveBadge';

interface IOrdinarBoxProps {
    removeEventFromCoupon: (index: number | undefined) => void;
    event: CouponEvent;
    index?: number;
}

export function OrdinarBox(props: IOrdinarBoxProps) {
    const dispatch = useDispatch();

    function removeEventFromCoupon() {
        props.removeEventFromCoupon(props.index);
    }

    function changeEventActiveStatus() {
        if (!props.event.selectionId) {
            throw Error('selectionId must be number, undefined passed');
        } else {
            dispatch(TOGGLE_ACTIVE_STATUS_COUPON_EVENT(props.event.selectionId));
        }
    }

    return (
        <>
            <div
                className={`${props.event.live ? 'border-2 border-[#EACD40] rounded-tl-[8px] rounded-tr-[8px]' : ''}`}>
                <CouponBoxHeader
                    isActive={Boolean(props.event.active)}
                    changeEventActiveStatus={changeEventActiveStatus}
                    removeEventFromCoupon={removeEventFromCoupon}
                    competitionName={props.event.competitionName}
                    marketName={props.event.marketName}
                />
                <div
                    className="flex justify-between items-center py-[13px] px-2.5 desktop:px-[16px] text-[12px] desktop:text-[16px] font-['Roboto'] leading-[100%] tablet:px[18px] text-white">
                    <span className="flex-1">{props.event.selectionName}</span>
                    <div className="flex items-center gap-2">
                        {props.event.live && <LiveBadge />}
                        <Coefficient odd={props.event.odds} direction={props.event.direction} />
                    </div>
                </div>
            </div>

            <Actions isOrdinar selectionId={props.event.selectionId} fixtureId={props.event.fixtureId} />
            <StepsCompute selectionId={props.event.selectionId} rate={props.event.rate ? props.event.rate : 0} />
        </>
    );
}
